import { Stack } from "@mui/material";
import { styled } from '@mui/material/styles';
import { colors } from "../../styles/defaultColors";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { createStyles, makeStyles } from "@material-ui/core";
import { SortArray } from "../../utils/App";
//import { useLocation } from "react-router";
//import { CountryService } from "../Admin/Countries/services/EquipmentCountry";
import React from "react";
import { useTranslation } from "react-i18next";
import CheckIcon from '@mui/icons-material/Check';
const useStyles = makeStyles(() =>
    createStyles({
        o: {},
        "@global": {
            ".MuiInput-underline:before, .MuiInput-underline:after": {
                display: "none"
            },
        },
    })
);


/** MAIN COMPONENT */
export const PnbPlaceQuartierSelector = (props: any) => {
    let isReadOnlyDefaultValue: boolean = props.isUpdating || false;
    const classes = useStyles();
    const [selectedQuartiers, setSelectedQuartiers] = React.useState<any[]>([]);
    const [quartierList, setQuartierList] = React.useState<any[]>()

    const { t } = useTranslation<'common'>();
   
    /* Event handler for selecting a city from the dropdown
    const handleQuartierSelect = (event: any, selectedQuartier: any) => {
        if (selectedQuartier) {
            setNomQuartier(selectedQuartier);
            props.onChangeSelect(selectedQuartier); // Notify parent
        } else {
            setNomQuartier("");
            props.onChangeSelect(""); // Notify parent about the reset
        }
    }; */

    const handleQuartierSelect = (event: any, newSelectedQuartiers: any[]) => {
        if (newSelectedQuartiers.length <= 5) {
            setSelectedQuartiers(newSelectedQuartiers);
            props.onChangeSelect(newSelectedQuartiers); // Notify parent of changes
        }
    };

    React.useEffect(() => {
        setSelectedQuartiers(props.selectedQuartierValues || []); // Sync with parent prop
    }, [props.selectedQuartierValues]);
    

    React.useEffect(() => {
        if (props.values && props.values.length > 0) {
            const sortedList = [...props.values].sort(SortArray);
            setQuartierList(sortedList); // Update quartier list
        } else {
            setQuartierList([]); // Clear quartier list if no values
            setSelectedQuartiers([]); // Clear selected quartiers
        }
    }, [props.values]);

    React.useEffect(() => {
        if (!quartierList?.length) {
            setSelectedQuartiers([]); // Clear `selectedQuartiers` when quartiers list is cleared
        }
    }, [quartierList]);
    
 
    return (
        <Stack direction="column" spacing={props.noHeading ? 0 : 1} marginBottom={props.noHeading ? 0 : 2}
            width={props.noHeading ? props.width ? props.width : "auto" : "100%"} >
            {!props.noHeading && <h3 style={{ fontSize: 14,marginTop:"14px", marginBottom:"6px", color: colors.black}}>{props.title}</h3>}
            {props.label ?? ''}
            
            <Autocomplete
                multiple
                freeSolo={false}
                id={props.id || 'quartierAutocomplete'}
                options={quartierList || []}
                className={classes.o}
                onChange={handleQuartierSelect}
                value={selectedQuartiers} // Controlled value
                forcePopupIcon={false}
                getOptionDisabled={(option) =>
                    selectedQuartiers.length >= 5 && !selectedQuartiers.includes(option)
                } // Disable unselected options if limit is reached
                noOptionsText={t("home.aucun-quartier-trouve")}
                disabled={isReadOnlyDefaultValue}
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        {selected && <CheckIcon style={{ marginRight: 8, color: "#890608" }} />}
                        {option}
                    </li>
                )}
                renderInput={(params) => (props.secondStyle ?
                    <PnbStyledCustomTextFieldSeconStyle
                        {...params}
                        onChange={(event: any) => console.log(event.target.value)}
                        placeholder={props.placeHolder}
                        value={props.selectedQuartierValues}
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                            autoComplete: 'off',
                            readOnly: true,
                        }}
                    /> :
                    (
                        props.blog ?
                            <PnbStyledCustomTextFieldBlog
                                {...params}
                                margin="dense"
                                size="small"
                                placeholder={props.placeHolder}
                                InputProps={{
                                    ...params.InputProps,
                                    type: 'search',
                                    autoComplete: 'off',
                                    startAdornment: props.preIcon,
                                    readOnly: true,
                                }}
                            />
                            :
                            <PnbStyledCustomTextField
                                {...params}
                                margin="dense"
                                size="small"
                                placeholder={props.placeHolder}
                                InputProps={{
                                    ...params.InputProps,
                                    type: 'search',
                                    autoComplete: 'off',
                                    startAdornment: props.preIcon,
                                    readOnly: true,
                                }}
                            />
                    )
                )}
            />
        </Stack>

    )
}

/** STYLED COMPONENTS */
export const PnbStyledCustomTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: colors.orangePng,
        },
        '&:hover fieldset': {
            borderColor: colors.orangeDark,
        },
        '&.Mui-focused fieldset': {
            borderColor: colors.orangePng,
        },
    },
    "@global": {
        ".css-f01iyf-MuiInputBase-input-MuiOutlinedInput-input::placeholder": {
            fontFamily: "Josefin Sans!important",
        },
        ".css-b7k0tb-MuiAutocomplete-listbox.MuiAutocomplete-option": {
            fontFamily: "Josefin Sans!important",
        }
    }
})


export const PnbStyledCustomTextFieldBlog = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: "#000000",
        },
    },
    "@global": {
        ".css-f01iyf-MuiInputBase-input-MuiOutlinedInput-input::placeholder": {
            fontFamily: "Josefin Sans!important",
        },
        ".css-b7k0tb-MuiAutocomplete-listbox.MuiAutocomplete-option": {
            fontFamily: "Josefin Sans!important",
        }
    }
})


export const PnbStyledCustomTextFieldSeconStyle = styled(TextField)(() => {

    return ({
        '& .MuiOutlinedInput-root': {
            color: "#000000 !important",
            fontFamily: "Josefin Sans !important",
            border: "none",
            margin: 0,
            fontSize: 12,
            padding: 0,
            '& fieldset': {
                border: 0,
                padding: 0,
                fontSize: 12,
            },
        },
        '& input, & .MuiInputBase-input': {
            color: "#000000 !important",
            margin: "0 !important",
            padding: "0 !important",
        },
        "@global": {
            '.css-1d5sc0w-MuiFormControl-root-MuiTextField-root': {
                margin: "0 !important"
            },
            ".css-b7k0tb-MuiAutocomplete-listbox.MuiAutocomplete-option": {
                fontFamily: "Josefin Sans!important",
            }
        }
    })
})

